import { useCallback, useEffect, useLayoutEffect, useRef } from 'react';
import { useDispatch } from "react-redux";
import { factoryActions } from "../../util/store/factory/reducer";
import { locationActions } from "../../util/store/location/reducer";
import { regionActions } from "../../util/store/region/reducer";
import { siteActions } from "../../util/store/site/reducer";
import { useSelector } from "../../util/store/store";
import { VESSEL_DEVICE_TYPE_NAME } from "../../util/varibles/constants";
import { IVessel } from "../../util/varibles/interface";
import { VIEW_MODE } from "../../util/varibles/permission";
import { SOCKET_FUNC, SOCKET_NAME } from "../../web-socket/constants";
import WSService from "../../web-socket/web-socket-service";
import Map from "./Map";
import { dashboardActions } from "./reducer";

const DashboardPage = () => {
    const dispatch = useDispatch();
    const permission = useSelector(state => state.login.user.permission);
    const gps = useRef<any>({});
    const timeout = useRef<ReturnType<typeof setTimeout>>();
    const groupIds = useRef<any[]>([]);
    const loadData = useRef(false);

    const registerWebSocket = useCallback((vessels: IVessel[]) => {
        if (vessels.length === 0) return;

        groupIds.current = vessels.reduce((list: any[], item: IVessel) => {
            return [...list, item.id, item.id + "-" + VESSEL_DEVICE_TYPE_NAME.LOCATION];
        }, []);

        new WSService({
            groups: groupIds.current,
            listener: {
                lev: SOCKET_NAME.PAGE,
                func: (response: any) => {
                    if (!response.function) return;

                    switch (response.function) {
                        case SOCKET_FUNC.VESSEL_GPS: {
                            if (timeout.current) clearTimeout(timeout.current);

                            const { vessel_id, name, value, time } = response;
                            const { time: oldTime = 0 } = gps.current;
                            const [gpsTime] = time.split('.');
                            const updateTime = gpsTime[gpsTime.length - 1] === 'Z'
                                ? new Date(gpsTime.replace(' ', 'T')).getTime()
                                : new Date(gpsTime.replace(' ', 'T') + 'Z').getTime();
                            const newTime = Math.max(updateTime, oldTime);
                            gps.current = {
                                ...gps.current,
                                [vessel_id]: { ...gps.current[vessel_id] || {}, [name]: value, time: newTime }
                            };
                            timeout.current = setTimeout(() => {
                                dispatch(dashboardActions.updatePositionVessel(gps.current));
                                gps.current = {};
                            }, 1000);
                            break;
                        }
                        case SOCKET_FUNC.OPERATION_STATE_CHANGE:
                        case SOCKET_FUNC.OPERATION_STATUS_CHANGE:
                        case SOCKET_FUNC.OPERATION_CONFIRMED: {
                            const list = response.message;
                            dispatch(dashboardActions.updateOperations(list));
                            dispatch(dashboardActions.updateOpsSiteByWs(list));
                            break;
                        }
                        case SOCKET_FUNC.ONGOING_UPDATE: {
                            const { operations = [] } = response.message;
                            const list = Array.isArray(operations) ? operations || [] : [];
                            dispatch(dashboardActions.updateOperations(list));
                            dispatch(dashboardActions.updateOpsSiteByWs(list));
                            break;
                        }
                        case SOCKET_FUNC.OPERATION_DELETED:
                            dispatch(dashboardActions.deleteOps(response.message));
                            break;
                        case SOCKET_FUNC.OPERATION_ETA_CHANGE:
                            dispatch(dashboardActions.updateEtaOperations(response));
                            break;
                        default:
                            return;
                    }
                }
            }
        });
    }, [dispatch]);

    useLayoutEffect(() => {
        let isActive = true;
        dispatch(dashboardActions.getVesselsRequest((vessels: IVessel[]) => {
            if (isActive) registerWebSocket(vessels);
        }));
        dispatch(siteActions.getOverview("site"));
        dispatch(regionActions.getRegions());
        dispatch(factoryActions.gets());
        dispatch(locationActions.getPois());

        return () => {
            isActive = false;
            WSService.close(SOCKET_NAME.PAGE, groupIds.current);
            if (timeout.current) clearTimeout(timeout.current);
        };
    }, [dispatch, registerWebSocket]);

    useEffect(() => {
        if (permission[VIEW_MODE.PLANNER] && !loadData.current) {
            loadData.current = true;
            dispatch(dashboardActions.getDataRequest());
        }
    }, [dispatch, permission]);

    return <div className="m-header flex bgPage">
        <Map />
    </div>;
};

export default DashboardPage;
